import React, { Component } from 'react';
import { range } from 'lodash';
import PropTypes from 'prop-types';
import gradient from 'tinygradient';
import Inner from './inner';
import styles from './styles.css';

class GradientWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  renderPattern() {
    const items = range(30);

    return (
      <div className={styles.pattern}>
        {items.map(item => (<div key={item}><span /></div>))}
      </div>
    );
  }

  render() {
    const {
      primaryColor, secondaryColor,
      children, className, withPattern,
    } = this.props;
    if (primaryColor && secondaryColor) {
      const gc = gradient(primaryColor, secondaryColor);
      return (
        <div
          className={className}
          style={{ position: 'relative', background: primaryColor, backgroundImage: gc.css('linear', 'to bottom left') }}
        >
          {withPattern && this.renderPattern()}
          <div className={styles.content}>
            <Inner onMounted={this.props.onMounted}>
              {children}
            </Inner>
          </div>
        </div>
      );
    }
    return children;
  }
}

GradientWrapper.propTypes = {
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  onMounted: PropTypes.func,
  withPattern: PropTypes.bool,
};

GradientWrapper.defaultProps = {
  primaryColor: null,
  secondaryColor: null,
  children: null,
  className: null,
  onMounted: () => {},
  withPattern: false,
};


export default GradientWrapper;
